import { createContainer } from './unstated'
import usePage from '../hooks/pages/usePage'
export const Pages = createContainer(usePage)